module.exports = __webpack_public_path__ + "img/guyu_icon@2x.78dc7952.png";